// AG-Grid 전역 설정
import {themeQuartz} from 'ag-grid-community';

export const AG_GRID_THEME = themeQuartz; // 전역 테마
export const AG_GRID_DEFAULT_HEIGHT = 520; // 기본 높이
export const AG_GRID_DEFAULT_PAGE_SIZE = 20; // 기본 페이지 사이즈
export const AG_GRID_DEFAULT_COL_DEF = {sortable: true, filter: true, resizable: true};

// 공통 페이지 사이즈 옵션
export const AG_GRID_PAGE_SIZE_OPTIONS = [15, 20, 30];

// 기본 그리드 옵션
export const AG_GRID_DEFAULT_OPTIONS = {
  domLayout: 'autoHeight',
  suppressPaginationPanel: false, // 페이지네이션 패널 표시 여부
  suppressHorizontalScroll: false,
  suppressScrollOnNewData: true,
};

// 행/헤더/페이지네이션 높이 기본값
export const AG_GRID_LOCALE_TEXT = {
    // Pagination / Status
    page: '페이지',
    more: '더보기',
    to: '~',
    of: '/',
    next: '다음',
    last: '마지막',
    first: '처음',
    previous: '이전',
    loadingOoo: '불러오는 중...',
    noRowsToShow: '표시할 행이 없습니다.',
    noMatches: '일치하는 항목이 없습니다.',

    // Set Filter / Text
    selectAll: '전체 선택',
    selectAllSearchResults: '검색 결과 전체 선택',
    searchOoo: '검색...',
    blanks: '(빈 값)',
    noMatchesFound: '일치 항목 없음.',

    // Number / Text filter conditions
    filterOoo: '필터...',
    equals: '같음',
    notEqual: '같지 않음',
    blank: '빈 값',
    notBlank: '빈 값 아님',
    lessThan: '미만',
    greaterThan: '초과',
    lessThanOrEqual: '이하',
    greaterThanOrEqual: '이상',
    inRange: '범위 내',
    inRangeStart: '시작',
    inRangeEnd: '끝',
    contains: '포함',
    notContains: '미포함',
    startsWith: '시작',
    endsWith: '끝남',

    // Filter Buttons
    applyFilter: '필터 적용',
    resetFilter: '필터 초기화',
    clearFilter: '필터 지우기',
    cancel: '취소',
    done: '완료',

    // Filter Titles
    textFilter: '텍스트 필터',
    numberFilter: '숫자 필터',
    dateFilter: '날짜 필터',
    setFilter: '세트 필터',

    // Side Bar / Tool Panel
    columns: '컬럼',
    filters: '필터',
    rowGroupColumns: '행 그룹 컬럼',
    pivotColumns: '피벗 컬럼',
    valueColumns: '값 컬럼',
    groupBy: '그룹화',
    values: '값',
    pivots: '피벗',
    groups: '그룹',

    // Column Menu
    pinColumn: '열 고정',
    pinLeft: '왼쪽에 고정',
    pinRight: '오른쪽에 고정',
    noPin: '고정 해제',
    autosizeThiscolumn: '이 열 너비 자동 맞춤',
    autosizeAllColumns: '모든 열 너비 자동 맞춤',
    resetColumns: '열 초기화',
    expandAll: '모두 펼치기',
    collapseAll: '모두 접기',
    copy: '복사',
    copyWithHeaders: '헤더 포함 복사',
    ctrlC: 'Ctrl+C',
    paste: '붙여넣기',
    ctrlV: 'Ctrl+V',

    // Aggregation / Status Bar
    sum: '합계',
    min: '최솟값',
    max: '최댓값',
    none: '없음',
    count: '개수',
    average: '평균',

    // Export
    export: '내보내기',
    csvExport: 'CSV 내보내기',
    excelExport: 'Excel 내보내기',
    download: '다운로드',

    // ARIA / Accessibility (간단 주요 항목)
    ariaSortAscending: '오름차순 정렬됨',
    ariaSortDescending: '내림차순 정렬됨',
    ariaColumn: '열',
    ariaRowSelect: '스페이스로 행 선택 전환',
    ariaRowDeselect: '스페이스로 행 선택 해제',
    ariaSearch: '검색',
};

export const csvExportOptions = {
    fileName: 'export.csv',
    columnSeparator: ',',
    suppressQuotes: false,
    allColumns: true, // 숨김 컬럼도 포함
};

export const excelExportOptions = {
    fileName: 'export.xlsx',
    allColumns: true, // 숨김 컬럼도 포함
};

export const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
};
